export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="empty-state">
      {Icon ? (
        <div className="empty-state-icon" aria-hidden>
          <Icon size={32} strokeWidth={1.5} />
        </div>
      ) : null}
      <div className="empty-state-title">{title}</div>
      {description ? <p className="empty-state-desc">{description}</p> : null}
      {action || null}
    </div>
  );
}
